import axios from "axios";
import Constants from "../../constants/Constants";

const namespaced = true;
const apiState = Constants.APPLICATION.API_STATE;
const state = {
  flamelink: {},
  apiState: Constants.APPLICATION.API_STATE.INIT,
};

const getters = {
  flamelink(state) {
    return state.flamelink;
  },
  apiState(state) {
    return state.apiState;
  },
};

const mutations = {
  setFlamelink(state, payload) {
    state.flamelink = payload;
  },
  addFlamelink(state, payload) {
    state.flamelink[payload.key] = payload.value;
  },
  setApiState(state, payload) {
    state.apiState = payload;
  },
};

const actions = {
  getFlamelink({ commit, dispatch, rootGetters }, payload) {
    commit("setApiState", apiState.LOADING);
    dispatch("loading/setLoading", true, { root: true });
    const url = `${rootGetters["settings/backend"].url}${payload}`;
    axios
      .get(url)
      .then((res) => {
        console.log(res.data);
        const data = {
          key: payload,
          value: res.data,
        };
        commit("addFlamelink", data);
        dispatch("loading/setLoading", false, { root: true });
        commit("setApiState", apiState.LOADED);
        // commit("setApiState", apiState.LOADED);
      })
      .catch((err) => {
        console.log("Error:", err);
      });
    commit("setApiState", apiState.LOADED);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
